var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"padding":"0"}},[_c('iframe',{staticStyle:{"height":"100%"},attrs:{"src":"https://kashichang.cn/su/rIJv6","width":"100%"}})])
}]

export { render, staticRenderFns }